import React from 'react';
import { Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import 'Components/Utility/Mobile/Backtotop.scss';

export default function BackToTopButton() {
  const scrollToTop = () => {
    document.body.scrollTop = 0; //  safari
    document.documentElement.scrollTop = 0; // ie, firefox, chrome;
  };

  return (
    <div className="mobile-cart-btn pb-3 pt-2">
      <div className="scroll-content container">
        <div className="d-flex w-100">
          <Button
            className="back-to-top-btn w-100"
            onClick={scrollToTop}
          >
            <FormattedMessage id="backtotopbutton.backtotop" defaultMessage="Back to top" />
          </Button>
        </div>
      </div>
    </div>
  );
}
